import { render, staticRenderFns } from "./recordView.component.vue?vue&type=template&id=558f2030&scoped=true&"
import script from "./recordView.component.vue?vue&type=script&lang=js&"
export * from "./recordView.component.vue?vue&type=script&lang=js&"
import style0 from "./recordView.component.vue?vue&type=style&index=0&id=558f2030&lang=scss&scoped=true&"
import style1 from "./recordView.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558f2030",
  null
  
)

export default component.exports